import { $apiClient } from '@msdk/common'
import { Entity } from '@msdk/definitions'
import { selector, selectorFamily } from 'recoil'

export const $documents = selector({
  key: 'LegalDocuments',
  get: async ({ get }) => {
    const client = get($apiClient)
    const response = await client.read<Entity[]>('CMPS/api/AdminPortal/sitemaplegaldocuments')
    return response as Entity[]
  },
})

export const $document = selectorFamily({
  key: 'LegalDocument',
  get:
    (params: Map<string, string>) =>
    async ({ get }) => {
      const client = get($apiClient)
      const entityName = params.get('entityName')
      const entityId = params.get('id')
      const file = params.get('file')
      const res = await client.read<string>(
        `CMPS/api/AdminPortal/documentcontent/${entityName}/${entityId}/FILE/${file}`,
      )
      return res
    },
})
